export default __webpack_public_path__ + "static/media/filter_icon_auditorium.5183eb30.svg";